import { NextRouter, useRouter } from "next/router";

interface ParsedQuery {
	userId: string | undefined;
	hashed: string | undefined;
	accountName: string | undefined;
	datasetId: string | undefined;
	groupId: string | undefined;
	mapId: string | undefined;
	mapName: string | undefined;
	layerId: string | undefined;
	layerGroupId: string | undefined;
	email: string | undefined;
	printPreview: boolean | undefined;
	token: string | undefined;
}

export const useWebRouter = (): NextRouter & {
	_query: ParsedQuery;
} => {
	const router = useRouter();

	return {
		...router,
		_query: {
			userId: router.query["user-id"] as string | undefined,
			hashed: router.query.hashed as string | undefined,
			accountName: router.query["account-name"] as string | undefined,
			datasetId: router.query["dataset-id"] as string | undefined,
			groupId: router.query["group-id"] as string | undefined,
			mapId: router.query["map-id"] as string | undefined,
			mapName: router.query["map-name"] as string | undefined,
			layerId: router.query["layer-id"] as string | undefined,
			layerGroupId: router.query["layer-group-id"] as string | undefined,
			email: router.query.email as string | undefined,
			printPreview:
				(router.query["print-preview"] as string | undefined) === "true",
			token: router.query.token as string | undefined,
		},
	};
};
